import React, { useState } from "react";
import { normalizeAvatarUrl, getBucketFromUrl } from "@/utils/avatarUrlUtils";
import { cn } from "@/lib/utils";

interface TemporaryStudentAvatarDisplayProps {
  avatarFileName?: string | null;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  bucket?: "temporary-student-avatars" | "avatars";
}

const TemporaryStudentAvatarDisplay: React.FC<TemporaryStudentAvatarDisplayProps> = ({
  avatarFileName,
  size = "md",
  className = "",
  bucket,
}) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-20 h-20",
  };

  const getAvatarUrl = (fileNameOrUrl: string | null | undefined) => {
    // Determine the bucket based on the URL path or use provided bucket prop
    if (!fileNameOrUrl) {
      // Return default avatar URL when no avatar is selected
      return normalizeAvatarUrl(null, "temporary-student-avatars");
    }
    const effectiveBucket = bucket || getBucketFromUrl(fileNameOrUrl);
    return normalizeAvatarUrl(fileNameOrUrl, effectiveBucket);
  };

  // If error loading, show placeholder
  if (imageError) {
    return (
      <div
        className={cn(
          sizeClasses[size],
          "rounded-full bg-muted flex items-center justify-center text-muted-foreground",
          className
        )}
      >
        <span className="text-xs font-semibold">?</span>
      </div>
    );
  }

  return (
    <div className={cn(sizeClasses[size], "rounded-full overflow-hidden bg-muted", className)}>
      <img
        src={getAvatarUrl(avatarFileName)}
        alt="Student avatar"
        className="w-full h-full object-contain"
        onError={() => {
          setImageError(true);
        }}
        onLoad={() => {
          // Avatar loaded successfully (silent)
        }}
      />
    </div>
  );
};

export default TemporaryStudentAvatarDisplay;
